import React from "react";
import { Box, BoxProps } from "@mui/material";
import { BORDER_RADIUS } from "../constants/typography";

interface BaseCardProps extends BoxProps {
  children: React.ReactNode;
}

const BaseCard: React.FC<BaseCardProps> = ({ children, sx, ...props }) => {
  return (
    <Box
      sx={{
        borderRadius: BORDER_RADIUS.CARD,
        backgroundColor: "#fff",
        color: "black",
        p: "3%",
        boxShadow: "0px 10px 20px 0px #0000000A",
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export default BaseCard;
